class PasswordValidator {
    /**
     * Create a new PasswordValidator instance.
     */
    constructor() {
        this.isLongEnough = false;
        this.hasANumber = false;
        this.isUpperAndLowercase = false;
        this.isConfirmed = false;
    }

    /**
     * Validate password.
     *
     * @param {string|null} password
     * @param {string|null} passwordConfirmation
     */
    run(password, passwordConfirmation = false) {
        if (passwordConfirmation) {
            this.isConfirmed = password.length > 0 && password == passwordConfirmation;
        }
        this.isLongEnough = password.length >= 8;
        this.hasANumber = /\p{N}/u.test(password);
        this.isUpperAndLowercase = /(\p{Ll}+.*\p{Lu})|(\p{Lu}+.*\p{Ll})/u.test(password);
    }
}

export default PasswordValidator;
